<template>
    <div>
        <!--        ToolBar-->
        <div class="panel panel-default">
            <div class="panel-body">
                <!--                Create button-->
                <button class="btn btn-success" title="Новая характеристика"
                        @click="create()">Створити характеристику
                </button>
                <!--                Search-->
                <div class="input-group input-group-sm" style="display: inline-block;">
                    <input type="text" name="__search__" class="form-control grid-quick-search" style="width: 200px;"
                           v-model="search" placeholder=" Пошук по id або назві">

                    <div class="input-group-btn" style="display: inline-block;">
                        <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
                    </div>

                </div>
                <div class="data_info" id="products_info">Знайдено записів: <strong>{{listCount}}</strong> </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-8 "
                 :class="{sort_container:!current_id}"
                 v-on="!current_id ? {dragover:dragover} : {}"
            >
                <div class="row root "
                     :class="{draggable:!current_id}"
                     :draggable="!current_id"
                     v-on="!current_id ? {dragstart:dragStart, dragend:dragEnd} : {}"
                     :id="item.id" v-for="(item,index) in filteredList">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <div class="input-group">
                                    <span class="input-group-addon  bold" @click="accordion(item.id)">
                                        <i class="fa fa-angle-down"></i>
                                    </span>
                                <span class="input-group-addon  addon-id">
                                        {{item.id}}
                                    </span>
<!--                                <span class="input-group-addon  addon-id">-->
<!--                                        ({{item.children.length}})-->
<!--                                </span>-->
                                <input type="text" class="form-control"
                                       v-model="item.name"
                                       @focus="onFocus(item,'name')"
                                       @keyup.esc="cancelEdit(item)"
                                       @keyup.enter="save(item)"
                                       @blur="cancelEdit(item)">
                                <input type="text" class="form-control"
                                       v-model="item.name_uk"
                                       placeholder="Укр"
                                       @focus="onFocus(item,'name_uk')"
                                       @keyup.esc="cancelEdit(item)"
                                       @keyup.enter="save(item)"
                                       @blur="cancelEdit(item)">
                                <span class="input-group-addon" title="Нове значення" @click="create(item)">
                                        <i class="fa fa-plus green"></i>
                                </span>
                                <span class="input-group-addon" title="Видалити"
                                      @click="remove(item)">
                                        <i class="fa fa-trash red"></i>
                                </span>
                                <span v-if="!current_id" class="input-group-addon cursor-move" title="Сортировка">
                                        <i class="fa fa-arrows"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <!--Children-->
                        <div v-if="current_id == item.id"
                             class="child"
                             :class="{sort_container:current_id == item.id}"
                             v-on="current_id == item.id ? {dragover:dragover} : {}"
                             >
                            <div class="col-sm-12"
                                 :class="{draggable:current_id == item.id}"
                                 :draggable="current_id == item.id"
                                 v-on="current_id == item.id ? {dragstart:dragStart, dragend:dragEnd} : {}"
                                 :id="child.id" v-for="(child,index) in item.children"
                            >
                                <div class="form-group">
                                    <div class="input-group">
                                    <span class="input-group-addon  addon-id">
                                        {{child.id}}
                                    </span>
                                        <input type="text" class="form-control"
                                               v-model="child.name"
                                               @focus="onFocus(child)"
                                               @keyup.esc="cancelEdit(child)"
                                               @keyup.enter="save(child)"
                                               @blur="cancelEdit(child)">
                                        <input type="text" class="form-control"
                                               v-model="child.name_uk"
                                               placeholder="Укр"
                                               @focus="onFocus(child)"
                                               @keyup.esc="cancelEdit(child)"
                                               @keyup.enter="save(child)"
                                               @blur="cancelEdit(child)">
                                        <span class="input-group-addon" title="Видалити"
                                              @click="remove(child)">
                                        <i class="fa fa-trash red"></i>
                                    </span>
                                        <span v-if="current_id === item.id" class="input-group-addon cursor-move" title="Сортировка">
                                        <i class="fa fa-arrows"></i>
                                </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        name: 'AttributesTree',
        props: ['link', 'attributes'],
        data() {
            return {
                items: this.attributes,
                children: [],
                current_id: null,
                editing: null,
                editing_uk: null,
                search: '',
            }
        },
        created() {

        },
        mounted() {
            // this.getRoots();
        },
        methods: {

            create(item = null) {
                let parent_id = null;
                let title = "Введіть назву нової характеристики";
                if (item) {
                    parent_id = item.id;
                    title = "Введіть нове значення для характеристики \n" + title;
                }

                Swal.fire({
                    title: title,
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Создать',
                    showLoaderOnConfirm: true,
                    inputValidator: function(value) {
                        if(value === '') {
                            return 'Напишіть тут щось!'
                        }
                    },
                    preConfirm: (value) => {
                        return axios.post(this.link, {
                            'parent_id': parent_id,
                            'name': value,
                        })
                            .then(response => {
                                toastr.success('Запис успішно створений!', response.data.name, {timeOut: 2000});
                                if (parent_id) {
                                    item.children.push(response.data);
                                    item.children.sort((a, b) => a.name.localeCompare(b.name, 'ru', {
                                        numeric: true,
                                        sensitivity: 'variant'
                                    }))
                                    this.current_id = parent_id;
                                } else {
                                    this.items.push(response.data);
                                    this.items.sort((a, b) => a.name.localeCompare(b.name, 'ru', {
                                        numeric: true,
                                        sensitivity: 'variant'
                                    }))
                                }

                            })
                            .catch(error => {
                                toastr.error(error.response.data, 'Помилка створення', {timeOut: 2000});
                            })
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                })
            },
            onFocus(item, field) {
                if (field == 'name_uk') {
                    this.editing_uk = item.name_uk;
                }
                this.editing = item.name;
            },
            cancelEdit: function (item, $event) {
                event.target.blur();
                if (this.editing != null) {
                    item.name = this.editing;
                }
                if (this.editing_uk != null) {
                    item.name_uk = this.editing_uk;
                }

            },
            save(item, $event) {
                let target = event.target;
                this.editing = item.name;
                this.editing_uk = item.name_uk;
                axios.put(this.link + '/'+item.id, {
                    'id': item.id,
                    'value': item.name,
                    'value_uk': item.name_uk,
                })
                    .then((response) => {
                        toastr.success(response.data, item.name, {timeOut: 2000});
                        this.editing = item.name;
                        this.editing_uk = item.name_uk;
                        target.blur();
                    })
            },
            remove(item) {
                Swal.fire({
                    title: 'Ви впевнені? Не пошкодуєте?',
                    text: "Буде безповоротно видалено значення \n" + item.name,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Відміна',
                    confirmButtonText: 'Так, Видалити!'
                }).then((result) => {
                    if (result.value) {
                        axios({
                            method: 'delete',
                            url: this.link + '/'+item.id
                        })
                            .then((response) => {
                                toastr.success(response.data, item.name);
                                if (!item.parent_id) {
                                    let i = this.items.map(item => item.id).indexOf(item.id);
                                    this.items.splice(i, 1);
                                } else {
                                    let i = this.items.map(item => item.id).indexOf(item.parent_id);
                                    let j = this.items[i].children.map(item => item.id).indexOf(item.id);
                                    this.items[i].children.splice(j, 1);
                                }

                            })
                            .catch((response) => {
                                toastr.error(response.data, item.name, {timeOut: 2000});
                            })
                    }
                })

            },
            accordion: function (id, $event) {
                this.current_id = this.current_id === id ? null : id;
            },
            dragStart(e){
                // console.log(e.target.classList)
                e.target.classList.add('dragging');
            },
            dragEnd(e){
                e.target.classList.remove('dragging');
                const container = document.querySelector('.sort_container');
                const draggableElements =[...container.querySelectorAll('.draggable')]

                var result = draggableElements.map(function(a) {return a.id;});

                axios.post(this.link + '/reorder', {
                    'newOrder': result,
                    'parent' : this.current_id,
                })
                    .then((response) => {
                        toastr.success("OK", {timeOut: 2000});
                    })

            },
            dragover(e){
                e.preventDefault();
                const draggable = document.querySelector('.dragging');
                const afterElement = this.getDragAfterElement(e.clientY);
                const container = document.querySelector('.sort_container');
                if (afterElement == null) {
                    container.appendChild(draggable)
                } else {
                    container.insertBefore(draggable, afterElement)
                }

            },
            getDragAfterElement(y){
                const container = document.querySelector('.sort_container');
                const draggableElements =[...container.querySelectorAll('.draggable:not(.dragging)')]
                return draggableElements.reduce((closest, child) => {
                    const box = child.getBoundingClientRect()
                    const offset = y - box.top - box.height / 2
                    if (offset < 0 && offset > closest.offset) {
                        return { offset: offset, element: child }
                    } else {
                        return closest
                    }
                }, { offset: Number.NEGATIVE_INFINITY }).element
            },
        },
        computed: {
            filteredList() {
                if (Object.keys(this.items).length > 0) {
                    return this.items.filter(item => {
                        return item.name.toString().toLowerCase().includes(this.search.toString().toLowerCase()) ||
                            item.id.toString().toLowerCase().includes(this.search.toString().toLowerCase()) ||
                            (item.name_uk  && item.name_uk.toString().toLowerCase().includes(this.search.toString().toLowerCase()));
                    })
                }
            },
            listCount() {
                if (this.filteredList) {
                    return this.filteredList.length;
                }
                return 0;
            }
        }
    }
</script>

<style scoped>

    .red {
        color: red;
    }

    .green {
        color: green;
    }

    .bold {
        font-weight: bolder;
    }

    .root input[type="text"]:first-of-type {
        background-color: #d1d1d1;
    }

    .root input[type="text"]:first-child {
        background-color: #e4e4e4;
    }

    .root input[type="text"]:focus {
        background-color: #fff4b3;
    }

    .root input[type="text"]:focus ~ span.edit {
        display: table-cell;
    }

    .input-group-addon {
        cursor: pointer;
    }

    .form-control {
        width: 50%;
    }

    .addon-id {
        min-width: 7rem;
    }

    .child {
        margin-left: 3rem;
        /*display: none;*/
    }

    .root.active > div.child {
        /*display: block !important;*/
    }

    .data_info {
        display: inline-block;
    }

    .sort_container1{
        height:66vh;
        overflow:scroll;
    }

    .draggable .cursor-move{
        cursor: move;
    }

    .draggable.dragging{
        opacity: .55;
    }
</style>
